import React, {useEffect, useState} from 'react';
import './App.css';
import Fuse from 'fuse.js';
import { useTranslation } from 'react-i18next';
import {SPResistanceElement, TableData, anyObject, tFuncFuseSearch, tEnviroment, tFuncUpdateSPEntry,tFilterObject, tActiveFilters,TableRow, tAppTempUnit} from './types/typedefinitons'
import i18n from './i18n/i18n';
import DisclaimerModal from './components/disclaimer_modal';
import {loadTheme, initializeIcons, Dropdown, appendFunction} from 'office-ui-fabric-react'
import ClassicView from './components/classicView/main';
import ViewSelection from './components/selectView';
import StandardView from './components/standardView/standardView';


initializeIcons();

loadTheme({
  palette:{
  "themePrimary": "#d80000",
  "themeLighterAlt": "#fdf3f3",
  "themeLighter": "#f9d1d1",
  "themeLight": "#f4aaaa",
  "themeTertiary": "#e85d5d",
  "themeSecondary": "#dd1b1b",
  "themeDarkAlt": "#c30000",
  "themeDark": "#a50000",
  "themeDarker": "#790000",
  "neutralLighterAlt": "#f8f8f8",
  "neutralLighter": "#f4f4f4",
  "neutralLight": "#eaeaea",
  "neutralQuaternaryAlt": "#dadada",
  "neutralQuaternary": "#d0d0d0",
  "neutralTertiaryAlt": "#c8c8c8",
  "neutralTertiary": "#bab8b7",
  "neutralSecondary": "#a3a2a0",
  "neutralPrimaryAlt": "#8d8b8a",
  "neutralPrimary": "#323130",
  "neutralDark": "#605e5d",
  "black": "#494847",
  "white": "#fff"
}}
)
// console.log('DDD', data)
const basicFetchOptions = {
  headers: {
    'Content-Type': 'application/json;odata=verbose',
    'accept': "application/json;odata=verbose",
  },
  method:'GET'
};

// const enviorment:tEnviroment = {
//   name: 'prod',
//   absolutSPPath: 'https://sp.gemue.biz',
//   // mainDataURL: '/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items?$top=5000&$select=Medium/Alternative_Namen_DE,Medium/Alternative_Namen_EN, Medium/Formel,Medium/GEMUEpedia_TitelDE,Medium/GEMUEpedia_TitelEN, Medium/CAS_Nr, Material, Material/Kategorie_txt, Material/Title,Material/GEMUEpedia_TitelDE, Konzentration_Lookup/GEMUEpedia_TitelDE,Konzentration_Lookup/GEMUEpedia_TitelEN,Zustand_Lookup/GEMUEpedia_TitelDE,Zustand_Lookup/GEMUEpedia_TitelEN,Anmerkungen/Text_DE,Anmerkungen/Text_EN,*&$expand=Material,Medium, Konzentration_Lookup, Zustand_Lookup, Anmerkungen',
//   mainDataURL:'/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items?$top=5000&$select=Id, MediumId, Medium/Alternative_Namen_DE,Medium/Alternative_Namen_EN, Medium/Formel,Medium/GEMUEpedia_TitelDE,Medium/GEMUEpedia_TitelEN, Medium/CAS_Nr, MaterialId, Material/Kategorie_txt, Material/Title,Material/GEMUEpedia_TitelDE, Material/GEMUEpedia_TitelEN, Konzentration_LookupId, Konzentration_Lookup/GEMUEpedia_TitelDE,Konzentration_Lookup/GEMUEpedia_TitelEN,Zustand_LookupId, Zustand_Lookup/GEMUEpedia_TitelDE,Zustand_Lookup/GEMUEpedia_TitelEN,AnmerkungenId,Anmerkungen/Text_DE,Anmerkungen/Text_EN,Bemerkung_DE,Bemerkung_EN,Eignung,Temperatur,Modified&$expand=Material,Medium, Konzentration_Lookup, Zustand_Lookup, Anmerkungen',
//   columnURL: '/gemuepedia/_api/web/lists/getbytitle(\'Resistance_materials_new\')/items?$top=5000&$orderby=Kategorie_DE',
//   standardView: 'select'
// }

const enviorment:tEnviroment = {
  name: 'public',
  absolutSPPath: '',
  // mainDataURL: '/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items?$top=5000&$select=Medium/Alternative_Namen_DE,Medium/Alternative_Namen_EN, Medium/Formel,Medium/GEMUEpedia_TitelDE,Medium/GEMUEpedia_TitelEN, Medium/CAS_Nr, Material, Material/Kategorie_txt, Material/Title,Material/GEMUEpedia_TitelDE,Material/GEMUEpedia_TitelEN, Konzentration_Lookup/GEMUEpedia_TitelDE,Konzentration_Lookup/GEMUEpedia_TitelEN,Zustand_Lookup/GEMUEpedia_TitelDE,Zustand_Lookup/GEMUEpedia_TitelEN,Anmerkungen/Text_DE,Anmerkungen/Text_EN,*&$expand=Material,Medium, Konzentration_Lookup, Zustand_Lookup, Anmerkungen',
  mainDataURL: './data/json/resistance.js',
  columnURL: './data/json/resistance_materials.js',
  standardView: 'standard'
}

// const enviorment:tEnviroment = {
//   name: 'dev',
//   absolutSPPath: 'https://wvsvde34.gemue.biz/node/nodeServer/SP?path=',
//   // mainDataURL: encodeURIComponent('/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items?$top=5000&$select=Medium/Alternative_Namen_DE,Medium/Alternative_Namen_EN, Medium/Formel,Medium/GEMUEpedia_TitelDE,Medium/GEMUEpedia_TitelEN, Medium/CAS_Nr, Material, Material/Kategorie_txt, Material/Title,Material/GEMUEpedia_TitelDE,Konzentration_Lookup/GEMUEpedia_TitelDE,Konzentration_Lookup/GEMUEpedia_TitelEN,Anmerkungen/Text_DE,Anmerkungen/Text_EN,Zustand_Lookup/GEMUEpedia_TitelDE,Zustand_Lookup/GEMUEpedia_TitelEN,*&$expand=Material,Medium, Konzentration_Lookup, Zustand_Lookup, Anmerkungen'),
//   mainDataURL: encodeURIComponent('/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items?$top=5000&$select=Id, MediumId, Medium/Alternative_Namen_DE,Medium/Alternative_Namen_EN, Medium/Formel,Medium/GEMUEpedia_TitelDE,Medium/GEMUEpedia_TitelEN, Medium/CAS_Nr, MaterialId, Material/Kategorie_txt, Material/Title,Material/GEMUEpedia_TitelDE, Material/GEMUEpedia_TitelEN, Konzentration_LookupId, Konzentration_Lookup/GEMUEpedia_TitelDE,Konzentration_Lookup/GEMUEpedia_TitelEN,Zustand_LookupId, Zustand_Lookup/GEMUEpedia_TitelDE,Zustand_Lookup/GEMUEpedia_TitelEN,AnmerkungenId,Anmerkungen/Text_DE,Anmerkungen/Text_EN,Bemerkung_DE,Bemerkung_EN,Eignung,Temperatur, Modified&$expand=Material,Medium, Konzentration_Lookup, Zustand_Lookup, Anmerkungen'),
//   columnURL: encodeURIComponent('/gemuepedia/_api/web/lists/getbytitle(\'Resistance_materials_new\')/items?$top=5000&$orderby=Kategorie_DE'),
//   standardView: 'select'
// }

// const enviorment:enviorment = {
//   name: 'devPublic',
//   absolutSPPath: 'https://wvsvde34.gemue.biz/node/nodeServer/SP?path=',
//   // mainDataURL: encodeURIComponent('/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items?$top=5000&$select=Id, MediumId, Medium/Alternative_Namen_DE,Medium/Alternative_Namen_EN, Medium/Formel,Medium/GEMUEpedia_TitelDE,Medium/GEMUEpedia_TitelEN, Medium/CAS_Nr, MaterialId, Material/Kategorie_txt, Material/Title,Material/GEMUEpedia_TitelDE, Konzentration_LookupId, Konzentration_Lookup/GEMUEpedia_TitelDE,Konzentration_Lookup/GEMUEpedia_TitelEN,Zustand_LookupId, Zustand_Lookup/GEMUEpedia_TitelDE,Zustand_Lookup/GEMUEpedia_TitelEN,AnmerkungenId,Anmerkungen/Text_DE,Anmerkungen/Text_EN,Bemerkung_DE,Bemerkung_EN,Eignung,Temperatur&$expand=Material,Medium, Konzentration_Lookup, Zustand_Lookup, Anmerkungen&$filter=Temperatur le 40'),
//   columnURL: encodeURIComponent('/gemuepedia/_api/web/lists/getbytitle(\'Resistance_materials_new\')/items?$top=5000&$orderby=Kategorie_DE')
// }

// const enviorment:enviorment = {
//   name: 'offline',
//   absolutSPPath: '',
//   mainDataURL: '/data/json/resistance.js',
//   columnURL: '/data/json/resistance_materials.js'
// }

const groupCheckUrl = '/gemuepedia/_api/web/sitegroups(2188)/CanCurrentUserViewMembership'

const digestPath = 'https://wvsvde34.gemue.biz/node/nodeServer/SP/getDigest?sc=/gemuepedia'

 const App: React.FC = () => {
  const { t, i18n } = useTranslation();

  type SPDigest = {
    key?:string,
    created?:Date
  };

  type materialRow = {
    Title:string,
    Id:number,
    GEMUEpedia_TitelDE:string,
    GEMUEpedia_TitelEN:string,
    Kategorie_TitelDE:string, 
    Kategorie_TitelEN:string
  };


  const defaultState:anyObject = {};
  const defaultArrayState:anyObject[] = [];

  const defaultResistanceElement:SPResistanceElement[] = [];
  const defaultRow:materialRow[] = [];
  const defaultDigest:SPDigest = {};

  const [dataSet, setDataSet] = useState(defaultState);
  const [rawData, setRawData] = useState(defaultResistanceElement);
  const [dropdownData, setDropdownData] = useState(defaultState);
  const [columnRequestError, setColumnRequestError] = useState('');
  const [columnDefs, setColumnDefs] = useState(defaultArrayState);
  const [fuseOptions, setFuseOptions] = useState(defaultState);
  const [searchActive, setSearchActive] = useState(false); 
  const [isAppAdmin, setIsAppAdmin] = useState(false);
  const [digest, setDigest] = useState(defaultDigest);
  const [isLoadingContent, setIsLoadingContent] = useState(false);
  const [loadedContentLength, setLoadedContentLength] = useState(0)
  const [rawColumnData, setRawColumnData] = useState(defaultRow);
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
  const [forceRefreshData, setForceRefreshData] = useState(false);
  const [materialSet, setMaterialSet] = useState<string[]>([]);
  const [view, setView] = useState(enviorment.standardView);
  // const [view, setView] = useState('standard');
  const [selectedValues, setSelectedValues] = useState<tActiveFilters>({material:[], medium:[]});
  const [appTempUnit, setappTempUnit] = useState<tAppTempUnit>({key:'celsius',text:'°C'})
  const [resultViewActive, setResultViewActive] = useState(false);
  const [latestChange, setLatestChange] = useState(new Date());


const doSpecificSearch = (filterArray:tFilterObject[]) => {
  // console.log(filterArray);
  let resultData:TableRow[] = [];
  let searchData = Object.values(convertData(rawData, appTempUnit).media) as TableRow[];
  if(filterArray.length > 0){
    filterArray.forEach((searchStep, searchStepIndex) => {
      let stepData:TableRow[] = [];
      // Prüfen, ob Suchbegriff ein Material ist
      // if(searchStep.resultType === 'material' && materialSet.indexOf(searchStep.filterValue.toUpperCase()) !== -1){
      //   searchStep.filterKeys = [searchStep.filterValue];
      //   searchStep.displayValue = searchStep.filterValue;
      //   searchStep.filterValue = '+';
        
      // }

        // let searchData = dataSet;
        // if(searchActive && searchStepIndex === 0){
        //   searchData = ;
        // }
        //SUCHE
        // console.log('Step:', searchData, searchStep);
        if(searchStep.resultType === 'medium'){
          stepData = Object.values(searchData).filter((dataPoint:TableRow) => {
            return dataPoint.Medium === searchStep.filterDataSpecificSearch?.Medium && dataPoint.Zustand === searchStep.filterDataSpecificSearch.Zustand;
          })
        }
        // else if(searchStep.resultType === 'material'){
        //   resultData = Object.values(searchData).filter((dataPoint:TableRow) => {
        //     return dataPoint. === searchStep.filterDataSpecificSearch?.Medium && dataPoint.Zustand === searchStep.filterDataSpecificSearch.Zustand;
        //   })
        // }

        resultData = [...resultData, ...stepData]
    });
    console.log('RESULT', resultData);
    setDataSet(resultData);
    setSearchActive(true);

  }
}


  function manageActiveSearchValues(action:string, changedValue?:tFilterObject) {
    if(action === 'set'){
        if(selectedValues[changedValue!.resultType].length > 0 ){
          removeFromSearch(selectedValues[changedValue!.resultType][0]).then((resukt) => {
            addToSearch(changedValue!);
          });
         
        }
        else{
          addToSearch(changedValue!);
        }
    }
    else if(action === 'remove'){
      	removeFromSearch(changedValue!);
    }
  };

  function addToSearch(changedValue:tFilterObject){
    return new Promise((resolve, reject) => {
      let newValues = JSON.parse(JSON.stringify(selectedValues));
      // Nur einen Materialfilter zulassen
      // if(!isMaterialFilterActive){
      //   if(changedValue && changedValue.resultType === 'material'){
      //     setIsMaterialFilterActive(true);
      //   }
      // }
      // else{
      //   alert('Es kann nach nur einem Material gefiltert werden')
      //   return false;
      // }
      console.log('changed', changedValue);
      if(changedValue) {
        // newValues[changedValue.resultType].push(changedValue);
        if(newValues[changedValue.resultType].length > 0){
          manageActiveSearchValues('remove', newValues[changedValue.resultType][0]);
  
        }else{
          newValues[changedValue.resultType].push(changedValue);
        }
       
  
      }
      console.log(newValues)
      setTimeout(()=>{setSelectedValues(newValues)},0);
      if(newValues.material.length > 0 || newValues.medium.length > 0){
        setTimeout(()=>{setResultViewActive(true)},0);
      }
      else{
        setResultViewActive(false)
      }
  
      let filterArray = [...newValues.material, ...newValues.medium];
      console.log(filterArray)
      if(view === 'standard'){
        doSpecificSearch(filterArray);
      }
      else{
        doFuseSearch(filterArray);
      }
      resolve('success');
    })
   

  }

  function removeFromSearch(changedValue:tFilterObject){
    return new Promise((resolve, reject) => {
      let newValues = selectedValues;
      if(changedValue!.resultType === 'material'){
        newValues[changedValue!.resultType] = newValues[changedValue!.resultType].filter(value => value.displayValue !== changedValue?.displayValue);
      }
      else{
        newValues[changedValue!.resultType] = newValues[changedValue!.resultType].filter(value => value.filterValue !== changedValue?.filterValue);
      }
      

      // if(changedValue && changedValue.filterValue === 'material'){
      //   setIsMaterialFilterActive(false);
      // }

      setSelectedValues(newValues);
      if(newValues.material.length > 0 || newValues.medium.length > 0){
        setResultViewActive(true)
      }
      else{
        setResultViewActive(false)
      }
      let filterArray = [...newValues.material, ...newValues.medium];
      doFuseSearch(filterArray);
      resolve('success');
    });
      
  }

  async function loadData(nextURL:string|undefined, prevReqResults:SPResistanceElement[]) {
    await getData(nextURL).then((result) => {
      let newData = [...prevReqResults, ...result.results];

     if(result['__next'] ){
        setIsLoadingContent(true);
        setLoadedContentLength(newData.length);
        let newURL = result['__next'].replace('https://sp.gemue.biz','');
        if(enviorment.name === 'dev' || enviorment.name === 'devMax40'){
          newURL = encodeURIComponent(result['__next'].replace('https://sp.gemue.biz',''));
        }
        
        loadData(newURL, newData);
        // const finalData = convertData(newData);
        // setDataSet(finalData);
        // setDropdownData(finalData)
        setRawData(newData);
     }
     else{
      setIsLoadingContent(false);
       const finalData = convertData(newData, appTempUnit);
       setDataSet(finalData.media);
       setDropdownData(finalData)
       setRawData(newData);
       setForceRefreshData(false);
       setMaterialSet(finalData.materials);
      //  Änderungsdatum
       setLatestChange(finalData.latestChange);
     }
    });
  };

    useEffect(() => {
      if(enviorment.name !== 'offline' && enviorment.name !== 'public'){
      const getUserPermission = async () => {
        await fetch(enviorment.absolutSPPath + groupCheckUrl,basicFetchOptions)
        .then(res => res.json())
        .then(JSONresult => setIsAppAdmin(JSONresult.d.CanCurrentUserViewMembership))
      };
      getUserPermission();
      }
    },[isAppAdmin])


  
  useEffect(() => {
    //Sprache aus Paramater:
    const URLParams = window.location.search.replace('?', '').split('&');
    let UrlLang:string|undefined;
    URLParams.forEach(param => {
      const keyValue = param.split('=');
      if(keyValue[0] === 'l'){
        UrlLang = keyValue[1];
        if(UrlLang.indexOf('_') !== -1){
          UrlLang= UrlLang.replace('_','-');
        }
      }
    });

    // Bei US automatisch auf Fahrenheit umstellen
    if(UrlLang === 'en-US'){
      setappTempUnit({text:'°F', key:'fahrenheit'});
    }

    if(UrlLang === 'de-DE' || UrlLang === 'de-AT' || UrlLang === 'de-CH' || UrlLang === 'en-GB' || UrlLang === 'fr-FR' || UrlLang === 'en-US'){
      i18n.changeLanguage(UrlLang);
    // Sprache vom SharePoint setzen
    } 
    else if(window.location.href.indexOf('sp.gemue.biz') !== -1){
      let l = 1031;
      //@ts-ignore
      if(typeof g_wsaLCID !== 'undefined'){
        //@ts-ignore
        l = g_wsaLCID;
      }

      // const l = 1033
      if(l === 1033){
        i18n.changeLanguage('en-GB');
      }
      else{
        i18n.changeLanguage('de-DE');
      } 
    }


      loadData(undefined, []);
      fetch(enviorment.absolutSPPath + enviorment.columnURL,basicFetchOptions)
        .then(res => res.json())
        .then(
          (APIresult) => {
            let rawResult = [];
            if(enviorment.name !== 'offline' && enviorment.name !== 'public'){
              rawResult = APIresult.d.results;
            }
            else{
              rawResult = APIresult.data.data;
            }

            const result = generateColumnDef(rawResult);
            // const materialSet = generateMaterialDefinition(rawResult);

            setColumnDefs(result);
            setRawColumnData(rawResult)
            initGlobalSearch();
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            setColumnRequestError(error);
            console.log(columnRequestError)
          }
        );
   
    const initGlobalSearch = () => {

      let fuseKeys = [
        'Medium',
        'Alternative_Namen',
        'Medium_alt',
        'Alternative_Namen_alt',
        'Formel',
        'CAS_Nr',
        // 'Konzentration',
        // 'Temperatur',
        // 'Zustand',
        'searchString',
        'Anmerkung',
        'Anmerkung_alt',
        'materialArray.name'
        // {name:'Bemerkung_DE', weight:1},
        // {name:'Bemerkung_EN', weight:1}
      ]


      setFuseOptions({
        shouldSort: true,
        // matchAllTokens: true,
        findAllMatches: true,
        includeMatches: true,
        threshold: 0.2,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        tokenize:true,
        useExtendedSearch: true,
        keys: fuseKeys
      });
  }

  },[]);

  useEffect(()=>{
    if(forceRefreshData){
      setDataSet(defaultState)
      loadData(undefined, []);
    }
  },[forceRefreshData])


  const doFuseSearch:tFuncFuseSearch = (data, event) => { 
    if(event){
      event.preventDefault();
    }
    console.log('SEARCHDATA', data);
    if(data.length > 0){
      data.forEach((searchStep, searchStepIndex) => {
        // Prüfen, ob Suchbegriff ein Material ist
        if(searchStep.resultType === 'material' && materialSet.indexOf(searchStep.filterValue.toUpperCase()) !== -1){
          searchStep.filterKeys = [searchStep.filterValue];
          searchStep.displayValue = searchStep.filterValue;
          searchStep.filterValue = '+';
          
        }

        let filterValue:string|{} = searchStep.filterValue;
        
        //Suche verbessern
        if(searchStep.filterData){
          filterValue = {$and:searchStep.filterData}
        }

        //Wenn schon Suche dann vorher wieder alle Ergebnisse laden
        let searchData = dataSet;
        if(searchActive && searchStepIndex === 0){
        searchData = Object.values(convertData(rawData, appTempUnit).media);
        }
        //SUCHE
        let localFuseOptions = fuseOptions;
        if(searchStep.filterKeys && searchStep.filterKeys.length > 0){
          localFuseOptions = JSON.parse(JSON.stringify(fuseOptions));
          localFuseOptions.keys = searchStep.filterKeys;
        }
        // Für klassische Ansicht Zustand, Konzentration, Temperatur wieder aufnehmen
        if(view === 'classic'){
          localFuseOptions.keys = [...localFuseOptions.keys, 'Zustand','Konzentration', 'Temperatur']
        } 

        console.log('result', searchData);
        if(fuseOptions && filterValue !== ''){
          const fuse = new Fuse(Object.values(searchData), localFuseOptions);
          const result = fuse.search(filterValue);

          console.log('result', result);
          let cleanResult = [];
          for(let resultItem in result){
            let typedResultItem:any = result[resultItem];
            cleanResult.push(typedResultItem.item)
          };
          console.log('result', cleanResult);
          // const newDataset = convertData(cleanResult)
          setDataSet(cleanResult);
          setSearchActive(true);
        }
      });
    }
    else{
      const newDataset = convertData(rawData, appTempUnit);
      setDataSet(newDataset.media);
      setSearchActive(false);
    }
  }

  const updateSharePointEntry:tFuncUpdateSPEntry = (id, newValue, rowData, materialId) => {
    console.log(id, rowData)
    const dataToSend:Partial<SPResistanceElement> = {Eignung:newValue, MediumId:rowData.MediumId, Konzentration_LookupId:rowData.KonzentrationId, Zustand_LookupId:rowData.ZustandId, Temperatur:parseInt(rowData.Temperatur), AnmerkungenId:rowData.AnmerkungenId,MaterialId:materialId};
    let body = {__metadata:{type:'SP.Data.Resistance_x005f_list_x005f_newListItem'}, ...dataToSend}
    console.log('Body', body)
    
    const doSharePointRequest = (srcDigest?:{key:string, created:Date}) => {
      let requestBody = {};
      let target = '';
      let additionalHaeders = {};

      if(id){
        target = '/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items(' + id + ')';
      }
      else{
        target = '/gemuepedia/_api/web/lists/getbytitle(\'Resistance_list_new\')/items'
      }

      if(window.location.href.indexOf('sp.gemue.biz') !== -1 ){
        requestBody = body;
        if(id){
          additionalHaeders = {
            'X-HTTP-Method':'MERGE',
            'IF-MATCH':'*',
            'X-RequestDigest': srcDigest ? srcDigest.key : digest.key
          }
        }
        else{
          additionalHaeders = {
            'X-RequestDigest': srcDigest ? srcDigest.key : digest.key
          }
        }
      }
      else {
        requestBody = {
          value: JSON.stringify(body), 
          digest: srcDigest ? srcDigest.key : digest.key,
          mode: id ? 'update' : 'new'
        }
      }

      const postOptions = {
        headers: {
          ...additionalHaeders,
          ...basicFetchOptions.headers
        }, 
        method:'POST', 
      };
      
      console.log('Post Options', postOptions)

      let request = {
        ...postOptions,
        body: JSON.stringify(requestBody)
      };

      console.log('REQUEST', request)
    
      fetch(enviorment.absolutSPPath + target,request)
      .then(res => {
        if (!res.ok) {
          alert('Der Eintrag konnte nicht aktualisiert werden!')
          throw Error(res.statusText);
      }
       res.text();
      }
      )
      .then(
        (APIresult) => {
          console.log('Sollte gute Nachrichten haben:', APIresult);
          alert(id ? 'Eintrag aktualisiert!' : 'Eintrag erstellt!')
          // console.log(APIresult.d);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          console.log(error);
        }
      );
      }
    
    if(!digest.key || new Date(digest.created!).getTime() <= (new Date().getTime() - 25*60*1000)){
      if(window.location.href.indexOf('sp.gemue.biz') !== -1 ){
        const curDigest = (document.getElementById('__REQUESTDIGEST') as HTMLInputElement).value;
        const localDigest = {key:curDigest, created:new Date()}
        setDigest(localDigest)
        doSharePointRequest(localDigest)
      } else {
        const digestOptions ={
          headers: {
            ...basicFetchOptions.headers, 
          }, 
          method:'POST'
        }
        fetch(digestPath, digestOptions)
        .then(res => res.json())
        .then(
          (APIresult) => {
            console.log('Sollte gute Nachrichten haben:', APIresult);
            setDigest(APIresult);
            doSharePointRequest(APIresult);
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            console.log(error);
          }
        );
      }
    }
    else{
      doSharePointRequest()
    }
  }

  const onLangChange = (targetLang:string) => {
    if(targetLang)
    i18n.changeLanguage(targetLang);
    const convertedData = convertData(rawData, appTempUnit);
    setDataSet(convertedData.media)
    setDropdownData(convertedData)
    setColumnDefs(generateColumnDef(rawColumnData))
  }

  const sortAlphaNum = (a:any, b:string|number) => {if(!a){return 0};return a.localeCompare(b, 'de', { numeric: true })};

  const generateColumnDef = (rawData:materialRow[]) => {
    let columnDefData:{}[] = [{headerName:'', groupId: 'general', children:[
      {headerName: t('table.head.Medium'), field:'MediumInfo', sortable:true, pinned: 'left', autoHeight: true, cellClass:'cell-wrap-text', width:250, cellRenderer:'FirstCellRenderer', filter:'customFilter', suppressSizeToFit:true, type:['notEditable','noAutoSize', 'JSON']},
      {headerName: t('table.head.Konzentration'), comparator:sortAlphaNum, field:'Konzentration', sortable:true, width:120, pinned: 'left',type:'notEditable', filter:'customFilter'},
      {headerName: t('table.head.Zustand'), field:'Zustand', sortable:true,pinned: 'left', width:80, type:'notEditable', filter:'customFilter'},
      {headerName: t('table.head.Temperatur'), field:'Temperatur', sortable:true, width:50, pinned: 'left', type:'notEditable', filter:'customFilter'},
    ]}
    ]
    let curCategory:any|null, lastCategory:string|null = null;
    let curObj:{headerName?:string, children?:{}[], groupId?:string, openByDefault?:boolean} = {}
    rawData.forEach( (row:materialRow, index:number) => { 
      curCategory = row[('Kategorie_Titel'+  (i18n.language === 'de-DE' ? 'DE' : 'EN') as keyof materialRow)];
      if(!curCategory){
        curCategory = row['Kategorie_TitelEN']
      }
      if(curCategory !== lastCategory || lastCategory === null ){
        if(index !== 0){
          columnDefData.push(curObj);
        }
        
        curObj = {headerName:curCategory, groupId: curCategory, openByDefault: true, children:[]};
      }
      let materialName:string =  row[('GEMUEpedia_Titel' + (i18n.language === 'de-DE' ? 'DE' : 'EN') as 'GEMUEpedia_TitelDE'| 'GEMUEpedia_TitelEN')];
      if(!materialName){
        materialName = row['GEMUEpedia_TitelEN'];
      }

      const materialNameParts = (materialName as string).split(' | ');
      const headerName = materialNameParts[0];
      const headerTooltip = materialNameParts[1];

      curObj.children!.push({headerName:headerName, headerTooltip:headerTooltip, field: materialName.replace(/\.|\//g,''), sortable:true, cellEditor:'MyCellEditor', cellRenderer:'ResistanceCellRenderer', tooltipField:row.GEMUEpedia_TitelDE.replace(/\.|\//g,'') + '_BemerkungDE', colId:row.Id, type:'resistanceInfo',filter:'customFilter', columnGroupShow:'opwn'})
      lastCategory = curCategory;
      if(index === rawData.length -1){
        columnDefData.push(curObj);
      }
    })
    console.log('columnDefData',columnDefData)
    return columnDefData;
  }

  // const generateMaterialDefinition = (rawData:materialRow[]) => {
  //   let result:{nameDE:string, nameEN:string, field:string, kategorieDE:string, kategorieEN:string}[] = [];
  //   rawData.forEach((row:materialRow) => {
  //     let materialResultRow:{nameDE:string, nameEN:string, field:string, kategorieDE:string, kategorieEN:string} = {
  //       'nameDE': row['GEMUEpedia_TitelDE'],
  //       'nameEN': row['GEMUEpedia_TitelEN'],
  //       'field': row.GEMUEpedia_TitelDE.replace(/\.|\//g,''),
  //       'kategorieDE': row['Kategorie_TitelDE'],
  //       'kategorieEN': row['Kategorie_TitelEN']
  //     }
  //     result.push(materialResultRow);
  //   })
    
  //   return result;
  // }

    const refreshAllData = () => {
      setForceRefreshData(true)
    }

    return (
      <>
      <div className={'gemu-rs-container' + (resultViewActive || view === 'classic' ? '' : ' centered')}>
        <div className={'gemu-rs-container-content'}>
        <div className="gemu-rs-header-row">
          <img className="gemu-rs-logo" src="./images/gemue-logo_rgb.png" alt="Logo" onClick={ enviorment.name !== 'public' ? ()=>{setView('select')} : ()=>{} }/>
          <h1 className="gemu-rs-applicationtitle">{t('headlines.resistanceInformation')}</h1>
          {enviorment.name !== 'public' ?     
            <div style={{float:'right', textAlign:'right'}}>
            <span className="rs-internal-stamp">
            <img src="./images/stamp.png" width="96px" alt="DE"/>
            </span>
            </div>
          :
          null
          }
          <div className="gemu-rs-tempunit-selection">
            {/* <Dropdown
              label={t('labels.selectTempUnit')}
              selectedKey={appTempUnit.key}
              options={[{key:'celsius', text:'°C'}, {key:'fahrenheit', text: '°F'}]}
              onChange={(e, value)=>{setappTempUnit( value ? {key:value?.key as any, text:value?.text as any} : {text:'°C',key:'celsius'} )}}
            /> */}
          </div>
        </div>
        {view === 'select' ? 
          <ViewSelection 
            setView = {setView}
          />
        :
        <>
        {view === 'standard' ?
          <StandardView 
            setView = {setView}
            dataForSearch={dropdownData}
            fuseOptions={fuseOptions}
            setSelectedValues = {manageActiveSearchValues}
            selectedValues = {selectedValues}
            dataToDisplay = {dataSet}
            columnDefs = {columnDefs}
            appTempUnit = {appTempUnit}
            resultViewActive={resultViewActive}
            isLoadingContent = {isLoadingContent}
            loadedContentLength = {loadedContentLength}  
          />
        :
        <ClassicView 
          dataSet = {dataSet}
          dropdownData = {dropdownData}
          // doFuseSearch = {doFuseSearch}
          isLoadingContent = {isLoadingContent}
          searchActive = {searchActive}
          fuseOptions = {fuseOptions}
          enviroment = {enviorment}
          columnDefs = {columnDefs}
          updateSharePointEntry = {updateSharePointEntry}
          isAppAdmin = {isAppAdmin}
          onLangChange = {onLangChange}
          refreshAllData = {refreshAllData}
          loadedContentLength = {loadedContentLength}
          setSelectedValues = {manageActiveSearchValues}
          selectedValues = {selectedValues}
          view = {view}      
        />
        }
        </>
        }
      </div>
      {view !== 'classic' ?
        <div className="gemu-rs-footer">
          <div className="gemu-rs-footer-container">
            <div>
              <p><b>{t('resistanceKeys.title')}</b></p>
              <ul className="gemu-rs-footer-list">
                <li><b>{t('resistanceKeys.+')}</b><br/>{t('resistanceDescriptions.+')}</li>
                <li><b>{t('resistanceKeys.o')}</b><br/>{t('resistanceDescriptions.o')}</li>
                <li><b>{t('resistanceKeys.-')}</b><br/>{t('resistanceDescriptions.-')}</li>
              </ul>
            </div>
            <div className="gemu-rs-footer-info-centered">
              {enviorment.name !== 'prod' && enviorment.name !== 'dev' ?
              <>
                <p><b>{t('labels.contact.title')}</b></p>
                <p style={{whiteSpace:'pre-line'}}>{t('labels.contact.text')}</p>
                <a className="gemu-rs-icon-link" href={i18n.language === 'de-DE' ? 'https://www.gemu-group.com/de_DE/kontakte/kontakte-weltweit/kontaktformular/': 'https://www.gemu-group.com/en_EN/contacts/contacts-worldwide/contact-form/'}>
                  <img src="./images/contact_icon.png" alt="contact" />
                  <span><strong>{t('labels.contact.button')}</strong></span>
                </a>
              </>
              :
              null
            }
            <p style={{textAlign:'right', marginTop:'40px', fontSize:'11px'}}>{t('labels.lastModified')}: {latestChange.toLocaleDateString()}</p>
            </div>    
          </div>
          {resultViewActive ?
          <div className='gemu-rs-footer-disclaimer'>
              <p>{t('disclaimerFooter.hastelloy')}</p>
            </div>
            :
            null
          }
        </div>
        :null
      }
      </div>
       {!disclaimerAccepted ? <DisclaimerModal acceptHandler={()=>setDisclaimerAccepted(true)}/> : null }
       </>
    )
  }

const getData = (customURL?:string) => {
  // langCode = langCode.toUpperCase();
  return new Promise<{results:SPResistanceElement[];__next?:string}>((resolve, reject) => {
    let requestPath = enviorment.mainDataURL;
    if(customURL !== undefined && customURL !== ''){
      requestPath = customURL
    }
    fetch(enviorment.absolutSPPath + requestPath,basicFetchOptions)
    .then(res => res.json())
    .then(
      (APIresult) => {
        if(enviorment.name !== 'offline' && enviorment.name !== 'public'){
          resolve(APIresult.d);
        }
        else{
          resolve({results:APIresult.data.data})
        }
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        reject(error);
      }
    )
    .catch(error =>{ 
      console.log(error);

    });
  })
 };

 const convertData = (srcData:SPResistanceElement[], appTempUnit:tAppTempUnit) => {
  let curLang = i18n.language;
  let spLang = 'DE';
  let spLangAlt = 'EN';

  if(curLang === 'en-GB' || curLang === 'en-US'){
    spLang = 'EN';
    spLangAlt = 'DE';
  }
  else if(curLang === 'fr-FR'){
    spLang = 'EN'
    spLangAlt = 'DE';
  }

  let altLang = 'en-GB'
  if(curLang === 'en-GB'){
    altLang = 'de-DE';
  }

  if(curLang === 'fr-FR'){
    curLang = 'en-GB';
  }
  
  let finalData:TableData = {};
  let materials:string[] = [];
  let materialsCheck:string[] = [];
  let latestChange = new Date(1/1/1970);
  if(enviorment.name !== 'offline' && enviorment.name !== 'public'){
  srcData.forEach((dataset:SPResistanceElement) => {
    const itemModifiedDate = new Date(dataset.Modified);
    if(itemModifiedDate > latestChange){
      latestChange = itemModifiedDate;
    }

    let material = dataset.Material['GEMUEpedia_Titel' + spLang];
    let rowIdentifier = dataset.Medium.GEMUEpedia_TitelDE + '_' + dataset.Konzentration_Lookup['GEMUEpedia_Titel' + spLang] + '_' + dataset.Zustand_LookupId + '_' + dataset.Temperatur;
    if(finalData[rowIdentifier] === undefined) {
      finalData[rowIdentifier] = {
        Medium: dataset.Medium['GEMUEpedia_Titel' + spLang],
        Medium_alt: dataset.Medium['GEMUEpedia_Titel' + spLangAlt],
        Anmerkung: dataset.Anmerkungen['Text_' + spLang],
        Anmerkung_alt: dataset.Anmerkungen['Text_' + spLangAlt],
        AnmerkungenId:dataset.AnmerkungenId,
        MediumInfo: JSON.stringify({medium:dataset.Medium['GEMUEpedia_Titel' + spLang], altName:dataset.Medium['Alternative_Namen_'+ spLang], CAS_Nr:dataset.Medium.CAS_Nr, Formel:dataset.Medium.Formel, Note:dataset.Anmerkungen['Text_' + spLang]}), 
        MediumId: dataset.MediumId,
        Alternative_Namen:dataset.Medium['Alternative_Namen_'+ spLang], 
        Alternative_Namen_alt:dataset.Medium['Alternative_Namen_' + spLangAlt], 
        Formel:dataset.Medium.Formel, 
        CAS_Nr:dataset.Medium.CAS_Nr, 
        Konzentration:dataset.Konzentration_Lookup['GEMUEpedia_Titel' + spLang],
        KonzentrationId:dataset.Konzentration_LookupId, 
        Zustand:dataset.Zustand_Lookup['GEMUEpedia_Titel' + spLang],
        ZustandId:dataset.Zustand_LookupId, 
        Temperatur: (appTempUnit.key === 'fahrenheit' ?  (dataset.Temperatur * 1,8 + 32).toString() : dataset.Temperatur.toString()), 
        searchString: dataset.Medium['GEMUEpedia_Titel' + spLang] + ' ' + dataset.Zustand_Lookup['GEMUEpedia_Titel' + spLang],
        materialArray: []
      };
    }

    const materialFieldName = material?.replace(/\.|\//g,'');

    finalData[rowIdentifier][materialFieldName] = dataset.Eignung;
    finalData[rowIdentifier][materialFieldName + '_Id'] =  dataset.Id;
    finalData[rowIdentifier][materialFieldName + '_BemerkungDE'] = dataset.Bemerkung_DE;
    finalData[rowIdentifier][materialFieldName + '_BemerkungEN'] = dataset.Bemerkung_DE;

    if(dataset.Eignung === '+' || dataset.Eignung === '(+)'){
      // if(finalData[rowIdentifier].materialArray.indexOf(material) === -1){
        finalData[rowIdentifier].materialArray.push({name:material,field:materialFieldName});
      // }
    }


    if(materialsCheck.indexOf(material) === -1){
      materials.push(material);
      materialsCheck.push(material);
    }

  });
  }
  else{
    srcData.forEach((dataset:any) => {
      const itemModifiedDate = new Date(dataset.modified);
      if(itemModifiedDate > latestChange){
        latestChange = itemModifiedDate;
      }

      let material = dataset.Material[0 ]['GEMUEpedia_Titel' + (i18n.language === 'de-DE' ?  'DE' : 'EN')];
      let rowIdentifier = dataset.Medium[0].GEMUEpedia_TitelDE + '_' + dataset.Konzentration_Lookup[0]?.Id + '_' + dataset.Zustand_Lookup[0]?.Id + '_' + dataset.Temperatur;
      if(finalData[rowIdentifier] === undefined)
        finalData[rowIdentifier] = {
          Medium: dataset.Medium[0]['GEMUEpedia_Titel' + spLang],
          Medium_alt: dataset.Medium[0]['GEMUEpedia_Titel' + spLangAlt],
          Anmerkung: dataset.Anmerkungen[0]?.['Text_' + spLang],
          Anmerkung_alt: dataset.Anmerkungen[0]?.['Text_' + spLangAlt],
          MediumInfo: JSON.stringify({medium:dataset.Medium[0]['GEMUEpedia_Titel' + spLang], altName:dataset.Medium[0]['Alternative_Namen_'+ spLang], CAS_Nr:dataset.Medium[0].CAS_Nr, Formel:dataset.Medium[0].Formel, Note:dataset.Anmerkungen[0]?.['Text_' + spLang]}), 
          MediumId: dataset.Medium[0]?.Id,
          Alternative_Namen:dataset.Medium[0]?.['Alternative_Namen_'+ spLang], 
          Alternative_Namen_alt:dataset.Medium[0]?.['Alternative_Namen_' + spLangAlt], 
          Formel:dataset.Medium[0]?.Formel, 
          CAS_Nr:dataset.Medium[0]?.CAS_Nr, 
          Konzentration:dataset.Konzentration_Lookup[0]?.['GEMUEpedia_Titel' + spLang],
          KonzentrationId:dataset.Konzentration_Lookup[0]?.Id, 
          Zustand:dataset.Zustand_Lookup[0]?.['GEMUEpedia_Titel' + spLang],
          ZustandId:dataset.Zustand_Lookup[0]?.Id, 
          Temperatur: (appTempUnit.key === 'fahrenheit' ? (dataset.Temperatur.split('.')[0] * 1.8 + 32) : dataset.Temperatur.split('.')[0]), 
          searchString: dataset.Medium[0]?.['GEMUEpedia_Titel' + spLang] + ' ' + dataset.Zustand_Lookup[0]?.['GEMUEpedia_Titel' + spLang],
          materialArray:[]
        };

        const materialFieldName = material.replace(/\.|\//g,'');

        finalData[rowIdentifier][materialFieldName] = dataset.Eignung;
        finalData[rowIdentifier][materialFieldName + '_Id'] =  dataset.Id;
        finalData[rowIdentifier][materialFieldName + '_BemerkungDE'] = dataset.Bemerkung_DE;
        finalData[rowIdentifier][materialFieldName + '_BemerkungEN'] = dataset.Bemerkung_DE;

        if(materialsCheck.indexOf(material) === -1){
          materials.push(material);
          materialsCheck.push(material);
        }

        if(dataset.Eignung === '+' || dataset.Eignung === '(+)'){
          // if(finalData[rowIdentifier].materialArray.indexOf(material) === -1){
            finalData[rowIdentifier].materialArray.push({name:material,field:materialFieldName});
          // }
        }
  
    });
  }

  let ordered:{[key:string]:{}} = {};
  Object.keys(finalData).sort().forEach(function(key) {
    ordered[key] = finalData[key];
  });

  //@ts-ignore
  // console.log(ordered)
  // if(ordered)
  //@ts-ignore
  // Object.values(ordered).forEach(test => test.materialArray.indexOf('PVC-C') !== -1 ? console.log(test.materialArray): null)


  return {media: ordered, materials:materials, latestChange:latestChange};
 }


export default App;
